import regexExps from "@/config/regexExps";

export default function numOnly(value: string) {
  const regexValue = new RegExp(regexExps.numOnly);

  return regexValue.test(value);
}
